import { Component } from 'react';
import { ErrorState } from './States';

/** Catches render errors in a screen so one broken page doesn't blank the whole app. */
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Message and component stack only; no props or state (could contain PII)
    console.error('[ErrorBoundary]', error?.message, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <section className="bg-surface-container-lowest rounded-xl border border-outline-variant/30 shadow-xs">
        <ErrorState
          icon="error"
          title={this.props.title ?? 'Something went wrong'}
          description="This screen hit an unexpected error. Try again, or reload the page if it keeps happening."
          onRetry={this.reset}
        />
      </section>
    );
  }
}
